/* eslint-disable indent */
import { FormInstance } from 'antd/lib/form';
import React, { useEffect, useState } from 'react';
import { ClientFeatureConfig } from '../../../types/Feature';
import FeatureStatusInput from '../../Shared/Inputs/FeatureStatusInput';

interface PreparationTimeFormSectionProps {
    formInstance: FormInstance;
    preparationTimeConfig?: ClientFeatureConfig<any>;
    isDetailMode?: boolean;
    enableControls?: boolean;
    resetFormFlag?: boolean;
}

const PreparationTimeFormSection: React.FC<PreparationTimeFormSectionProps> = (
    props: PreparationTimeFormSectionProps,
) => {
    const { formInstance, preparationTimeConfig, isDetailMode, enableControls, resetFormFlag } = props;

    const [isFeatureDisabled, setIsFeatureDisabled] = useState<boolean>(!preparationTimeConfig?.config.enabled);
    const [isPrepNowDisabled, setIsPrepNowDisabled] = useState<boolean>(!preparationTimeConfig?.config.prepNowEnabled);

    useEffect(() => {
        setIsFeatureDisabled(true);
    }, [resetFormFlag]);

    useEffect(() => {
        if (preparationTimeConfig) {
            formInstance.setFields([
                { name: 'preparationTimeEnabled', value: preparationTimeConfig.config.enabled },
                { name: 'prepNowEnabled', value: preparationTimeConfig.config.prepNowEnabled },
            ]);
            setIsFeatureDisabled(!preparationTimeConfig.config.enabled);
            setIsPrepNowDisabled(!preparationTimeConfig?.config.prepNowEnabled);
        }
    }, [preparationTimeConfig]);

    return (
        <>
            <div className="card border-0" id="fleets-section">
                <div className="card-header border-bottom d-flex justify-content-between align-items-center bg-white">
                    <p className="m-0 p-0 h5" style={{ fontSize: '18px' }}>
                        Preparation Time
                    </p>
                    <div className="d-inline-flex align-items-center">
                        <span className="mr-2 d-none d-sm-block">Feature is:</span>
                        <FeatureStatusInput
                            name="preparationTimeEnabled"
                            id="preparationTimeEnabled"
                            isDetailMode={isDetailMode}
                            enabled={preparationTimeConfig?.config.enabled}
                            isFeatureDisabled={isFeatureDisabled}
                            onChange={(value): void => {
                                setIsFeatureDisabled(!value);
                                if (!value) {
                                    setIsPrepNowDisabled(true);
                                    formInstance.setFields([{ name: 'prepNowEnabled', value: false }]);
                                }
                            }}
                            enableControls={enableControls}
                        />
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-inline-flex align-items-center">
                        <span className="mr-2 d-none d-sm-block">Check status in Prep-now app:</span>
                        <FeatureStatusInput
                            name="prepNowEnabled"
                            id="prepNowEnabled"
                            isDetailMode={isFeatureDisabled}
                            enabled={!isPrepNowDisabled}
                            isFeatureDisabled={isPrepNowDisabled}
                            onChange={(value): void => {
                                setIsPrepNowDisabled(!value);
                            }}
                            enableControls={enableControls}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default PreparationTimeFormSection;
